import Model, { attr, hasMany, type AsyncHasMany } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type PersonModel from './person';
import type TeamModel from './team';

export default class RoleModel extends Model {
  declare [Type]: 'role';
  @attr('string') declare name: string;
  @attr('number') declare ftes: number;
  @hasMany('person', { async: true, inverse: 'roles' })
  declare people: AsyncHasMany<PersonModel>;

  get activePeople() {
    return (this.people.content ?? []).filter((person) => person.active);
  }

  get teamsThatPeopleOfThisRoleAreIn() {
    const teams: TeamModel[] = [];
    const people = this.people.content ?? [];
    people.forEach((person) => {
      const _teams = person.teams.content ?? [];
      if (_teams) teams.push(..._teams);
    });
    const uniqueTeams = Array.from(new Set(teams));
    return uniqueTeams;
  }
}
